import get from 'lodash/get';
import { createSelector } from 'reselect';
import requestSelector from '../request/selectors';
import uiSelector from '../ui/selectors';
import configSelector from '../config/selectors';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export default selector;

export const tempDashboardDataSelector = createSelector(
  [requestSelector, uiSelector, configSelector],
  (requestStore, uiStore, configStore) => ({
    request: requestStore,
    ui: uiStore,
    config: configStore,
  }),
);
